export const time = {
  spin: 0.4,
  regular: 1.5,
  big: 3.3,
  ultra: 3.3,
  mega: 3.3,
  multiply: 1,
}
